module.exports = __webpack_public_path__ + "static/media/MyPhoto.a8cbc8d7.jpg";